<payee-chip-dropdown
  [selected]="value"
  [placeholder]="'Hitelezők'"
  [displayWith]="displayClient"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="removed()"
>
  <payee-form-field width="wide">
    <payee-autocomplete
      placeholder="Válassz hitelezőt"
      [formControl]="formControl"
      [options]="clientOptions"
      [displayWith]="displayClient"
      (searchChange)="setClients$.next($event)"
    ></payee-autocomplete>
  </payee-form-field>
  <button
    payee-button
    color="primary"
    class="top-margin-10"
    width="wide"
    (click)="apply()"
  >
    Alkalmaz
  </button>
</payee-chip-dropdown>
